import React, { createContext, useState, useMemo } from 'react';

// only to check is search page open or not in global context of the app

export const SearchContext = createContext();


const SearchContextProvider = ({ children }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [searchString, setSearchString] = useState('');

    const contextValue = useMemo(() => ({
        isOpen,
        setIsOpen,
        searchString,
        setSearchString
    }), [isOpen, setIsOpen, searchString, setSearchString]);

    return (
        <SearchContext.Provider value={contextValue}>
            {children}
        </SearchContext.Provider>
    );
}

export default SearchContextProvider;
